export default __webpack_public_path__ + "apply4_18a5de0.png";